<template>
  <div class="course_introduce mb-10" v-if="listTotal != 0">
    <div class="course_top flex Flexalign FlexBetween px-20 py-10">
      <div class="course_contents">课程附件</div>
      <div class="flex Flexalign">
        <div class="auto_text">数量：{{ listTotal }}</div>
      </div>
    </div>
    <div class="class_info_list scroll_y hidden_scroll" v-if="listTotal != 0">
      <div
        class="info_one flex py-12 px-20 Flexalign FlexBetween cursor_pointer"
        v-for="(item, index) in infoList"
        :key="index"
        @click="viewFolder(item)"
      >
        <div class="flex Flexalign" style="width:100%;">
          <el-image
            class="video_class"
            :src="getFolderIcon(item.fileExt)"
          ></el-image>
          <div class="ml-15 flex-1 toverflow">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="empty_box" v-else>
      <moe-empty
        url="moe_empty_bg_img.png"
        emptyText="暂无课程附件"
      ></moe-empty>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5ClassWare",
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  watch: {
    selectLearningInfo: {
      handler() {
        this.getFileList();
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      infoList: [],
      listQuery: {
        page: 1,
        pageSize: 999,
        sceneId: "",
        dirPath: "/",
      },
      listTotal: "",
    };
  },

  mounted() {
    this.getFileList();
  },

  methods: {
    getFolderIcon(type) {
      let iconPath = "";
      if (type == "") {
        // 文件夹
        iconPath = "folder_icon";
      } else if (type == ".png" || type == ".jpg") {
        // 图片
        iconPath = "img_icon";
      } else if (type == ".pdf") {
        // pdf
        iconPath = "pdf_icon";
      } else if (type == ".mp4") {
        // 视频
        iconPath = "player_icon";
      } else if (type == ".ppt" || type == ".pptx") {
        // ppt
        iconPath = "ppt_icon";
      } else if (type == ".txt") {
        // txt文档
        iconPath = "txt_icon";
      } else if (type == ".mp3") {
        // 音频
        iconPath = "video_icon";
      } else if (type == ".doc" || type == ".docx") {
        // word
        iconPath = "word_icon";
      } else if (type == ".zip" || type == ".rar") {
        // 压缩包
        iconPath = "zip_icon";
      } else {
        iconPath = "default_folder_icon";
      }
      return this.imgPath(iconPath + ".png");
    },
    getFileList() {
      this.infoList = [];
      this.listTotal = 0;
      this.listQuery.sceneId = this.selectLearningInfo?.id;
      if (!this.listQuery.sceneId) return;
      this.$Api.course
        .getFileList(this.listQuery)
        .then((res) => {
          this.infoList = res.data.data.list;
          this.listTotal = res.data.data.total;
        })
        .catch(() => {});
    },
    // 查看文件
    viewFolder(info) {
      window.open(info.storageUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.course_introduce {
  background: #ffffff;
  width: 330px;
  max-height: 620px;
  //   padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 10px;
  // overflow-y: auto;
  position: relative;

  .course_top {
    .course_contents {
      font-weight: bold;
      font-size: 18px;
      color: #111111;
    }

    .auto_text {
      font-size: 14px;
      color: #13d6aa;
      margin-right: 5px;
    }
  }
  .class_info_list {
    max-height: 240px;
    .info_one {
      .video_class {
        width: 24px;
        height: 24px;
      }
    }
    .info_one_active {
      background: #f6faff;
    }
  }
  .empty_box{
    max-height: 300px;
  }
}
</style>
